

import { customAxios } from './customAxios'
export function getAbilitazioneTastoChiuso(idNodoPratica) {
    const config = {
        params: { idPratica: idNodoPratica.toString() },
        headers: {
            Accept: "*/*",
            'AuthToken': JSON.parse(localStorage.getItem('token'))
        },
    }
    const getAbilitazioneTastoChiuso =
        customAxios.get(process.env.REACT_APP_BACKEND_HOST + `/`+process.env.REACT_APP_PATH_NEW_PREFIX+`/abilitaChiuso?`, config).then(response => response.data.body)
    return getAbilitazioneTastoChiuso
}